import { HeaderProps } from "../types/header-props";
import { SortDirection } from "../types/sort-direction";

export interface ColumnHeaderProps<TSort> {
    column: HeaderProps<TSort>;
    sort: { column?: TSort, direction?: SortDirection, setColumn: (sort: TSort) => void; toggleDirection: () => void; }
    SortIcon?: React.FunctionComponent<{ isActive: boolean, direction: SortDirection }>
}

export function ColumnHeader<TSort = string>({column, sort, SortIcon}: ColumnHeaderProps<TSort>) {
    const onClick = () => {
        if (!column.sort) { return; }

        if (sort.column === column.sort) {
            sort.toggleDirection();
        } else {
            sort.setColumn(column.sort);
        }
    }

    return (
        <div className="d-flex">
            {typeof (column.header) === 'string' ?
                <span className="align-self-center me-2">
                    {column.header}
                </span> :
                column.header
            }

            {column.sort && sort.direction && <button className="btn btn-link" onClick={onClick}>
                {SortIcon ? <SortIcon isActive={!!sort.column && column.sort === sort.column} direction={sort.direction} /> : (<>{sort.direction}</>) }
            </button>}
        </div>
    );
}

